module.exports = __webpack_public_path__ + "static/media/carry-04.343bbfb8.png";